<tam-dialog tid="template_setting_dialog" class="template-setting-dialog " [opened]="opened">
    <ng-template #title>
        <span class="dialog-title">Contact template configuration</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)"
            [hidden]="attachmentUploading||attachmentRenaming">
        </smart-icon>
    </ng-template>

    <ng-template #body>

        <div class="setting-dialog-body">
            <div class="contact-template-setting-field">
                <tam-template-setting-fields *ngIf="tplConfig" [config]="tplConfig"></tam-template-setting-fields>
            </div>
            <div class="vertical-divider"></div>
            <div class="contact-template-setting-layout">
                <tam-template-setting-layout *ngIf="tplConfig" [config]="tplConfig">
                </tam-template-setting-layout>
            </div>
            <div class="vertical-divider"></div>
            <div class="contact-template-setting-config">
                <tam-template-setting-config *ngIf="tplConfig" [config]="tplConfig"></tam-template-setting-config>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="template-reset-default"><button tam-button tamType="secondary" tamSize="normal" class="dialog-button"
                (click)="clickResetDefault($event)">Reset to
                default</button>
        </div>
        <div>
            <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                (click)="cancel()">
                Cancel</button>
            <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                (click)="saveTemplate()">Save template</button>
        </div>
    </ng-template>
</tam-dialog>